































import Vue from 'vue';
import MStoreDeleteConfirmation from './MStoreDeleteConfirmation.vue';
export default Vue.extend({
  components: { MStoreDeleteConfirmation },
  name: 'MStoreDeleteConfirmationModal',
  data() {
    return {
      showDeleteConfirmation: false
    };
  },
  props: {
    canCopyPaste: {
      type: Boolean,
      default: true
    },
    entityNameToDelete: {
      type: String,
      required: true
    },
    entityTypeToDelete: {
      type: String,
      required: true
    },
    additionalEntityInformation: {
      type: String
    },
    entityPk: {
      type: Number,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    disabledReason: {
      type: String
    }
  },
  methods: {
    onDeleteClicked(this: any) {
      this.showDeleteConfirmation = true;
    },
    onDeleteConfirmationClicked(this: any) {
      this.showDeleteConfirmation = false;
      this.$emit('on-delete-confirmation', this.entityPk);
    },
    onCancelDeleteConfirmationClicked(this: any) {
      this.showDeleteConfirmation = false;
      this.$emit('on-cancel-delete-confirmation');
    }
  },
  computed: {
    entityDescriptionToDelete(this: any) {
      return `'${this.entityNameToDelete}' ${this.entityTypeToDelete}`;
    }
  }
});
